export const APP_VERSION: string = '2.7.0-SNAPSHOT'; // END_VERSION value overwritten at build time
export const BUILD_DATE: string = '27/05/2025, 09:38:39'; // END_BUILD_DATE value overwritten at build time

export interface ICoopConfig {
  version: string;
  buildDate: string;
}

export default () => {
  const coopConfig: ICoopConfig = (window as any).coopConfig || {};
  coopConfig.version = APP_VERSION;
  coopConfig.buildDate = BUILD_DATE;

  (window as any).coopConfig = coopConfig;
};
